import React, { useState } from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { PostureScanInfoModal } from './PostureScanInfoModal';
import './PostureScanWidget.css';

type Props = {
  className?: string;
};

const PostureScanWidget: React.FC<Props> = ({ className }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div className={`posturescan-widget ${className || ''}`}>
      <div className="hoverable cursor-pointer" role="button" onClick={() => setModalShow(true)}>
        <img 
          src={toAbsoluteUrl('/media/partner/posturescan.png')} 
          width="100%" 
          alt="Posture Scan" 
          className="card-p-5 shadow rounded-corners" 
        />
      </div>
      <PostureScanInfoModal show={modalShow} handleClose={() => setModalShow(false)} />
    </div>
  );
};

export { PostureScanWidget };
